import { ALL_GATEWAYS_ORDER } from '../const'
import { AllGatewaysRequest, SystemGateway, SystemGatewayDto } from './types'

export const buildAllGatewaysQuery = ({
  gatewayId,
  internalName,
  page,
  pageSize,
}: AllGatewaysRequest): Record<string, string> => {
  const where: Record<string, string> = { isDisable: 'false' }

  if (gatewayId) where.id = gatewayId
  if (internalName) where.internalName = internalName.toLowerCase()

  return {
    page: String(page),
    limit: String(pageSize),
    order: ALL_GATEWAYS_ORDER,
    where: JSON.stringify(where),
  }
}

export const toSystemGateway = ({
  gatewayId,
  internalName,
}: SystemGatewayDto): SystemGateway => ({
  gatewayId: Number(gatewayId),
  internalName,
})
